import { render } from "./RelatedProductCourse.vue?vue&type=template&id=65c119ec"
import script from "./RelatedProductCourse.vue?vue&type=script&lang=js"
export * from "./RelatedProductCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__